@if (clippedSearch()) {
    <div class="padding-1 primary-gradient-bg-100 m-2 clip3 search-container w-100">
        <span class="search d-flex search-bg h-100 clip3">
        <span class="material-icons-sharp font-8 primary-text-100 ms-2 mt-2">search</span>
        <input 
        [value]="inputValue()"
        (input)="searchEntity($event)" 
        type="text" class="form-control bg-transparent border-0 primary-text px-3 py-2">
    </span>
    </div>

}@else {
    <div class="border-faded p-2 rounded align-item-center d-flex">
        <span class="material-icons-sharp font-8 primary-text-100 me-2">search</span>
        <input 
        [value]="inputValue()"
        (input)="searchEntity($event)" 
        type="text" class="border-0 bg-transparent flex-grow-1 primary-text p-0 form-control">
    </div>
}
